import {createRouter, createWebHistory} from 'vue-router';
import AccueilView from '@/views/AccueilView.vue';
import ServicesView from '@/views/ServicesView.vue';
import AproposView from '@/views/AproposView.vue';
import ContactView from '@/views/ContactView.vue';
import MentionsLegales from '@/views/MentionsLegales.vue';
import ApplicationWebView from "@/views/services/ApplicationWebView.vue";
import ConceptionView from "@/views/services/ConceptionView.vue";
import DefenseView from "@/views/services/DefenseView.vue";
import DessinView from "@/views/services/DessinView.vue";
import InstructionView from "@/views/services/InstructionView.vue";
import ISTCView from "@/views/services/ISTCView.vue";
import RenduView from "@/views/services/RenduView.vue";
import SiteVitrineView from "@/views/services/SiteVitrineView.vue";
import WordpressView from "@/views/services/WordpressView.vue";
import ErrorView from '@/views/ErrorView.vue';


const routes = [

    {
    name: 'Accueil',
    path: '/',
    component: AccueilView,
    },
    {
        name: 'Services',
        path: '/services',
        component: ServicesView,
    },
    {
        name: 'Apropos',
        path: '/apropos',
        component: AproposView,
    },
    {
        name: 'Contact',
        path: '/contact',
        component: ContactView,
    },
    {
        name: 'MentionsLegales',
        path: '/mentionslegales',
        component: MentionsLegales,
    },
    {
        name: 'ErrorView',
        path: '/error',
        component: ErrorView,
    },
    {
        name: 'ApplicationWeb',
        path: '/application-web',
        component: ApplicationWebView,
    },
    {
        name: 'Conception',
        path: '/conception',
        component: ConceptionView,
    },
    {
        name: 'Defense',
        path: '/defense',
        component: DefenseView,
    },
    {
        name: 'Dessin',
        path: '/mise-en-plan',
        component: DessinView,
    },
    {
        name: 'Instruction',
        path: '/instruction',
        component: InstructionView,
    },
    {
        name: 'ISTC',
        path: '/istc',
        component: ISTCView,
    },
    {
        name: 'Rendu',
        path: '/rendu-realiste',
        component: RenduView,
    },
    {
        name: 'SiteVitrine',
        path: '/site-vitrine',
        component: SiteVitrineView,
    },
    {
        name: 'Wordpress',
        path: '/wordpress',
        component: WordpressView,
    },
];


const router = createRouter({
    history:createWebHistory(),
    routes,
});

export default router;